export const InternalLinkIcon = ({ extraClass = "" }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="inherit"
    xmlns="http://www.w3.org/2000/svg"
    className={`w-20 h-20 1024:w-24 1024:h-24 ${extraClass}`}
  >
    <path
      d="M6 12H18.5M18.5 12L12.5 6M18.5 12L12.5 18"
      stroke="inherit"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ExternalLinkIcon = ({ extraClass = "" }) => (
  <svg
    viewBox="0 0 25 24"
    fill="none"
    stroke="inherit"
    xmlns="http://www.w3.org/2000/svg"
    className={`w-20 h-20 1024:w-24 1024:h-24 ${extraClass}`}
  >
    <path
      d="M9.67137 14.8284L15.3282 9.17152M15.3282 9.17152H10.3785M15.3282 9.17152V14.1213M12.5 22C18.0228 22 22.5 17.5228 22.5 12C22.5 6.47715 18.0228 2 12.5 2C6.97715 2 2.5 6.47715 2.5 12C2.5 17.5228 6.97715 22 12.5 22Z"
      stroke="inherit"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ExternalLinkSimpleIcon = ({ extraClass = "" }) => (
  <svg
    className={`w-20 h-20 ${extraClass}`}
    viewBox="0 0 20 20"
    fill="inherit"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.41797 14.9999L14.5846 5.83325M14.5846 5.83325V14.6333M14.5846 5.83325H5.78464"
      stroke="inherit"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ExternalLinkSimpleSmIcon = ({ extraClass = "" }) => (
  <svg
    width="8"
    height="8"
    viewBox="0 0 8 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.828125 7L6.82807 1ZM6.82807 1H1.57813ZM6.82807 1V6.25001Z"
      fill="#303337"
    />
    <path
      d="M0.828125 7L6.82807 1M6.82807 1H1.57813M6.82807 1V6.25001"
      stroke="#303337"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DownloadIcon = ({ extraClass = "" }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`w-20 h-20 1024:w-24 1024:h-24 ${extraClass}`}
  >
    <line
      x1="12.189"
      y1="5"
      x2="12.189"
      y2="15"
      stroke="inherit"
      strokeWidth="1.5"
    />
    <path
      d="M17.3242 10L12.3657 15L7.40712 10"
      stroke="inherit"
      strokeWidth="1.5"
    />
    <path d="M3 14V19H20.6304V14" stroke="inherit" strokeWidth="1.5" />
  </svg>
);

export const ChooseLocationIcon = ({ extraClass = "" }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="inherit"
    xmlns="http://www.w3.org/2000/svg"
    className={`w-20 h-20 1024:w-24 1024:h-24 ${extraClass}`}
  >
    <path
      d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
      stroke="inherit"
      strokeWidth="1.5"
    />
    <path
      d="M15.0381 6.82579L15.1517 13.8501L8.96249 17.1741L8.84892 10.1497L15.0381 6.82579Z"
      stroke="inherit"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
);

export const TalkToAnExpertIcon = ({ extraClass = "" }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="inherit"
    xmlns="http://www.w3.org/2000/svg"
    className={`w-20 h-20 1024:w-24 1024:h-24 ${extraClass}`}
  >
    <path
      d="M8 10L16 10M8 14H12M22 12C22 17.5228 17.5228 22 12 22C10.1786 22 8.47087 21.513 7 20.6622L2.5 21.5L3.33782 17C2.48697 15.5291 2 13.8214 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
      stroke="inherit"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PlusIcon = ({ extraClass }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="inherit"
    className={extraClass}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 10H10M15 10H10M10 10V5M10 10V15"
      stroke="inherit"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PinIcon = () => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.02 22L11.5045 22.5448L12.02 23.0326L12.5355 22.5448L12.02 22ZM19.2822 10C19.2822 10.907 18.8601 12.0704 18.127 13.3706C17.4052 14.6506 16.433 15.9753 15.4457 17.1819C14.4606 18.3856 13.4736 19.4559 12.7317 20.226C12.3612 20.6107 12.0529 20.9195 11.8378 21.1314C11.7303 21.2374 11.6461 21.3191 11.5893 21.374C11.5609 21.4014 11.5393 21.4221 11.525 21.4358C11.5178 21.4426 11.5125 21.4477 11.5091 21.4509C11.5074 21.4525 11.5061 21.4537 11.5053 21.4544C11.505 21.4548 11.5047 21.4551 11.5046 21.4552C11.5045 21.4553 11.5045 21.4553 11.5044 21.4553C11.5045 21.4553 11.5045 21.4552 12.02 22C12.5355 22.5448 12.5356 22.5447 12.5357 22.5445C12.5358 22.5444 12.536 22.5443 12.5362 22.5441C12.5365 22.5438 12.537 22.5433 12.5376 22.5428C12.5388 22.5417 12.5404 22.5401 12.5426 22.5381C12.5468 22.534 12.553 22.5281 12.561 22.5205C12.5771 22.5052 12.6004 22.4827 12.6307 22.4536C12.6912 22.3952 12.7792 22.3097 12.8908 22.1997C13.1139 21.9798 13.4315 21.6618 13.8121 21.2666C14.5725 20.4771 15.5885 19.3758 16.6065 18.1318C17.6222 16.8907 18.6531 15.4916 19.4336 14.1073C20.2028 12.7433 20.7822 11.3021 20.7822 10H19.2822ZM12.02 22C12.5355 21.4552 12.5355 21.4553 12.5356 21.4553C12.5355 21.4553 12.5355 21.4553 12.5354 21.4552C12.5353 21.4551 12.535 21.4548 12.5347 21.4544C12.5339 21.4537 12.5327 21.4525 12.5309 21.4509C12.5275 21.4477 12.5222 21.4426 12.5151 21.4358C12.5008 21.4221 12.4792 21.4014 12.4507 21.374C12.3939 21.3191 12.3097 21.2374 12.2022 21.1314C11.9871 20.9195 11.6788 20.6107 11.3083 20.226C10.5664 19.4559 9.57937 18.3856 8.59433 17.1819C7.60698 15.9753 6.63477 14.6506 5.91302 13.3706C5.1799 12.0704 4.75781 10.907 4.75781 10H3.25781C3.25781 11.3021 3.83725 12.7433 4.60642 14.1073C5.38695 15.4916 6.4178 16.8907 7.43349 18.1318C8.4515 19.3758 9.46748 20.4771 10.2279 21.2666C10.6086 21.6618 10.9262 21.9798 11.1492 22.1997C11.2608 22.3097 11.3488 22.3952 11.4093 22.4536C11.4396 22.4827 11.463 22.5052 11.479 22.5205C11.487 22.5281 11.4932 22.534 11.4975 22.5381C11.4996 22.5401 11.5013 22.5417 11.5024 22.5428C11.503 22.5433 11.5035 22.5438 11.5038 22.5441C11.504 22.5443 11.5042 22.5444 11.5043 22.5445C11.5044 22.5447 11.5045 22.5448 12.02 22ZM4.75781 10C4.75781 5.99701 8.00813 2.75 12.02 2.75V1.25C7.18186 1.25 3.25781 5.16643 3.25781 10H4.75781ZM12.02 2.75C16.0319 2.75 19.2822 5.99701 19.2822 10H20.7822C20.7822 5.16643 16.8582 1.25 12.02 1.25V2.75ZM12.02 11.75C12.9863 11.75 13.7715 10.9676 13.7715 10H12.2715C12.2715 10.137 12.16 10.25 12.02 10.25V11.75ZM13.7715 10C13.7715 9.03243 12.9863 8.25 12.02 8.25V9.75C12.16 9.75 12.2715 9.86301 12.2715 10H13.7715ZM12.02 8.25C11.0537 8.25 10.2685 9.03243 10.2685 10H11.7685C11.7685 9.86301 11.88 9.75 12.02 9.75V8.25ZM10.2685 10C10.2685 10.9676 11.0537 11.75 12.02 11.75V10.25C11.88 10.25 11.7685 10.137 11.7685 10H10.2685Z"
      fill="#303337"
    />
  </svg>
);

export const PinMapSearchIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 22L11.4841 22.5444L12 23.0333L12.5159 22.5444L12 22ZM19.25 10C19.25 10.9073 18.8284 12.0709 18.0965 13.371C17.3758 14.651 16.4051 15.9758 15.4192 17.1823C14.4357 18.386 13.4501 19.4563 12.7094 20.2264C12.3395 20.6111 12.0316 20.9199 11.8169 21.1318C11.7095 21.2378 11.6255 21.3195 11.5687 21.3744C11.5403 21.4018 11.5188 21.4225 11.5045 21.4362C11.4974 21.443 11.4921 21.448 11.4886 21.4513C11.4869 21.4529 11.4857 21.4541 11.4849 21.4548C11.4845 21.4552 11.4843 21.4554 11.4841 21.4556C11.4841 21.4556 11.4841 21.4557 11.484 21.4557C11.484 21.4557 11.4841 21.4556 12 22C12.5159 22.5444 12.516 22.5443 12.5162 22.5441C12.5162 22.5441 12.5164 22.5439 12.5166 22.5437C12.5169 22.5434 12.5174 22.543 12.518 22.5424C12.5192 22.5413 12.5208 22.5397 12.523 22.5377C12.5272 22.5336 12.5334 22.5277 12.5414 22.5201C12.5574 22.5048 12.5807 22.4823 12.611 22.4532C12.6714 22.3948 12.7592 22.3093 12.8706 22.1993C13.0934 21.9794 13.4105 21.6614 13.7906 21.2662C14.5499 20.4767 15.5643 19.3754 16.5808 18.1314C17.5949 16.8902 18.6242 15.4911 19.4035 14.1069C20.1716 12.7428 20.75 11.3018 20.75 10H19.25ZM12 22C12.5159 21.4556 12.516 21.4557 12.516 21.4557C12.5159 21.4557 12.5159 21.4556 12.5159 21.4556C12.5157 21.4554 12.5155 21.4552 12.5151 21.4548C12.5143 21.4541 12.5131 21.4529 12.5114 21.4513C12.5079 21.448 12.5026 21.443 12.4955 21.4362C12.4812 21.4225 12.4597 21.4018 12.4313 21.3744C12.3745 21.3195 12.2905 21.2378 12.1831 21.1318C11.9684 20.9199 11.6605 20.6111 11.2906 20.2264C10.5499 19.4563 9.56431 18.386 8.58078 17.1823C7.59493 15.9758 6.6242 14.651 5.90354 13.371C5.17155 12.0709 4.75 10.9073 4.75 10H3.25C3.25 11.3018 3.82845 12.7428 4.59646 14.1069C5.3758 15.4911 6.40507 16.8902 7.41922 18.1314C8.43569 19.3754 9.45014 20.4767 10.2094 21.2662C10.5895 21.6614 10.9066 21.9794 11.1294 22.1993C11.2408 22.3093 11.3286 22.3948 11.389 22.4532C11.4193 22.4823 11.4426 22.5048 11.4586 22.5201C11.4666 22.5277 11.4728 22.5336 11.477 22.5377C11.4792 22.5397 11.4808 22.5413 11.482 22.5424C11.4826 22.543 11.4831 22.5434 11.4834 22.5437C11.4836 22.5439 11.4838 22.5441 11.4838 22.5441C11.484 22.5443 11.4841 22.5444 12 22ZM4.75 10C4.75 5.99594 7.99594 2.75 12 2.75V1.25C7.16751 1.25 3.25 5.16751 3.25 10H4.75ZM12 2.75C16.0041 2.75 19.25 5.99594 19.25 10H20.75C20.75 5.16751 16.8325 1.25 12 1.25V2.75ZM12 11.75C12.9665 11.75 13.75 10.9665 13.75 10H12.25C12.25 10.1381 12.1381 10.25 12 10.25V11.75ZM13.75 10C13.75 9.0335 12.9665 8.25 12 8.25V9.75C12.1381 9.75 12.25 9.86193 12.25 10H13.75ZM12 8.25C11.0335 8.25 10.25 9.0335 10.25 10H11.75C11.75 9.86193 11.8619 9.75 12 9.75V8.25ZM10.25 10C10.25 10.9665 11.0335 11.75 12 11.75V10.25C11.8619 10.25 11.75 10.1381 11.75 10H10.25Z"
      fill="#303337"
    />
  </svg>
);

export const FlagIcon = () => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.51562 21V5C5.51562 3.89543 6.41106 3 7.51563 3H17.537C18.6415 3 19.537 3.89543 19.537 5V21L13.6066 17.1935C12.9484 16.7709 12.1042 16.7709 11.4459 17.1935L5.51562 21Z"
      stroke="#303337"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ContractIcon = () => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.0371 11H17.0448M12.0371 7H17.0448M8.03105 15V3.6C8.03105 3.26863 8.30009 3 8.63197 3H20.4499C20.7818 3 21.0509 3.26863 21.0509 3.6V17C21.0509 19.2091 19.2573 21 17.0448 21M8.03105 15H5.02648C3.92023 15 3.02344 15.8954 3.02344 17V18C3.02344 19.6569 4.36863 21 6.02801 21H17.0448M8.03105 15H12.4378C12.7696 15 13.0418 15.2668 13.0685 15.5971C13.1915 17.1147 13.821 21 17.0448 21"
      stroke="#303337"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ClockIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 2L15 2M12 10V14M20 14C20 18.4183 16.4183 22 12 22C7.58172 22 4 18.4183 4 14C4 9.58172 7.58172 6 12 6C16.4183 6 20 9.58172 20 14Z"
      stroke="#303337"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BreadcrumbDivider = ({ extraClass = "#78838C" }) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    className={extraClass}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.5 9L7.5 6L4.5 3"
      stroke="inherit"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const LinkedinIcon = () => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.045 23.9966H19.0644V16.2005C19.0644 14.342 19.0309 11.9516 16.4743 11.9516C13.8842 11.9516 13.4886 13.9781 13.4886 16.068V23.9966H8.51172V7.96777H13.2852V10.1584H13.3542C14.0204 8.89889 15.6439 7.57031 18.0679 7.57031C23.1138 7.57031 24.045 10.888 24.045 15.2059V23.9966Z"
      fill="#303337"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.89244 5.77895C1.29133 5.77895 0 4.48396 0 2.88854C0 1.29499 1.29133 0 2.89244 0C4.48421 0 5.77927 1.29499 5.77927 2.88854C5.77927 4.48396 4.48421 5.77895 2.89244 5.77895Z"
      fill="#303337"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.394531 24.0005H5.38258V7.97168H0.394531V24.0005Z"
      fill="#303337"
    />
  </svg>
);

export const FacebookIcon = () => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.0313 0C5.40398 0 0.03125 5.40034 0.03125 12.0617C0.03125 18.109 4.46307 23.102 10.2378 23.9742V15.2586H7.26889V12.088H10.2378V9.9783C10.2378 6.48535 11.9309 4.95187 14.8191 4.95187C16.2023 4.95187 16.9338 5.05494 17.2802 5.10209V7.8697H15.31C14.0838 7.8697 13.6556 9.03803 13.6556 10.355V12.088H17.2491L16.7614 15.2586H13.6556V24C19.5127 23.2012 24.0313 18.1676 24.0313 12.0617C24.0313 5.40034 18.6585 0 12.0313 0Z"
      fill="#303337"
    />
  </svg>
);

export const InstagramIcon = () => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.07195 0.0722133C8.35187 0.0138139 8.76053 0 12.0196 0C15.2785 0 15.6872 0.0138139 16.9671 0.0722133C18.2444 0.13047 19.1167 0.333343 19.88 0.630008C20.6691 0.936629 21.3383 1.34695 22.0055 2.01406C22.6726 2.68123 23.0829 3.35044 23.3896 4.13954C23.6862 4.90283 23.8891 5.77516 23.9473 7.05241C24.0057 8.33234 24.0195 8.741 24.0195 12C24.0195 15.259 24.0057 15.6677 23.9473 16.9476C23.8891 18.2248 23.6862 19.0972 23.3896 19.8605C23.0829 20.6496 22.6726 21.3188 22.0055 21.9859C21.3383 22.6531 20.6691 23.0634 19.88 23.37C19.1167 23.6667 18.2444 23.8695 16.9671 23.9278C15.6872 23.9862 15.2785 24 12.0196 24C8.76053 24 8.35187 23.9862 7.07195 23.9278C5.79469 23.8695 4.92236 23.6667 4.15908 23.37C3.36997 23.0634 2.70076 22.6531 2.0336 21.9859C1.36648 21.3188 0.95616 20.6496 0.64954 19.8605C0.352875 19.0972 0.150001 18.2248 0.0917445 16.9476C0.0333451 15.6677 0.0195312 15.259 0.0195312 12C0.0195312 8.741 0.0333451 8.33234 0.0917445 7.05241C0.150001 5.77516 0.352875 4.90283 0.64954 4.13954C0.95616 3.35044 1.36648 2.68123 2.0336 2.01406C2.70076 1.34695 3.36997 0.936629 4.15908 0.630008C4.92236 0.333343 5.79469 0.13047 7.07195 0.0722133ZM19.0948 2.6469C18.672 2.48256 18.0366 2.28707 16.8666 2.23372C15.6012 2.17599 15.2217 2.16375 12.0176 2.16375C8.81341 2.16375 8.43386 2.17599 7.16851 2.23372C5.99852 2.28707 5.36313 2.48256 4.94029 2.6469C4.38016 2.86459 3.98041 3.12462 3.56052 3.54456C3.14057 3.96446 2.88054 4.3642 2.66285 4.92433C2.49851 5.34718 2.30302 5.98257 2.24967 7.15256C2.19194 8.41791 2.1797 8.79746 2.1797 12.0016C2.1797 15.2057 2.19194 15.5853 2.24967 16.8506C2.30302 18.0206 2.49851 18.656 2.66285 19.0788C2.88054 19.639 3.14062 20.0387 3.56052 20.4586C3.98041 20.8786 4.38016 21.1386 4.94029 21.3563C5.36313 21.5206 5.99852 21.7161 7.16851 21.7695C8.43372 21.8272 8.81317 21.8394 12.0176 21.8394C15.2219 21.8394 15.6014 21.8272 16.8666 21.7695C18.0366 21.7161 18.672 21.5206 19.0948 21.3563C19.6549 21.1386 20.0547 20.8786 20.4746 20.4586C20.8945 20.0387 21.1545 19.639 21.3722 19.0788C21.5366 18.656 21.7321 18.0206 21.7854 16.8506C21.8431 15.5853 21.8554 15.2057 21.8554 12.0016C21.8554 8.79746 21.8431 8.41791 21.7854 7.15256C21.7321 5.98257 21.5366 5.34718 21.3722 4.92433C21.1545 4.3642 20.8945 3.96446 20.4746 3.54456C20.0547 3.12462 19.6549 2.86459 19.0948 2.6469ZM12.0185 5.83675C8.61515 5.83675 5.85628 8.59562 5.85628 11.9989C5.85628 15.4022 8.61515 18.1611 12.0185 18.1611C15.4217 18.1611 18.1806 15.4022 18.1806 11.9989C18.1806 8.59562 15.4217 5.83675 12.0185 5.83675ZM8.01645 12.0005C8.01645 14.2096 9.8073 16.0005 12.0165 16.0005C14.2256 16.0005 16.0164 14.2096 16.0164 12.0005C16.0164 9.79134 14.2256 8.00049 12.0165 8.00049C9.8073 8.00049 8.01645 9.79134 8.01645 12.0005ZM18.4261 7.03225C19.2214 7.03225 19.8662 6.38757 19.8662 5.59227C19.8662 4.79697 19.2214 4.15224 18.4261 4.15224C17.6309 4.15224 16.9862 4.79697 16.9862 5.59227C16.9862 6.38757 17.6309 7.03225 18.4261 7.03225Z"
      fill="#303337"
    />
  </svg>
);

export const YoutubeIcon = () => (
  <svg
    width="35"
    height="24"
    viewBox="0 0 35 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1394_137889)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.2674 1.82457C32.7985 2.35661 33.1811 3.01992 33.3769 3.74788C34.0723 6.42051 34.0863 12 34.0863 12C34.0863 12 34.0863 17.5795 33.3769 20.2521C33.1794 20.978 32.796 21.639 32.265 22.1689C31.734 22.6989 31.0741 23.0792 30.3513 23.2719C27.6957 23.9887 17.0401 23.9887 17.0401 23.9887C17.0401 23.9887 6.3872 23.9887 3.73169 23.2832C3.00981 23.0879 2.35161 22.705 1.82305 22.1731C1.29448 21.6411 0.914114 20.9787 0.72006 20.2521C0.0078125 17.5795 0.0078125 12 0.0078125 12C0.0078125 12 0.0078125 6.42051 0.72006 3.74788C0.914114 3.02135 1.29448 2.35891 1.82305 1.82694C2.35161 1.29496 3.00981 0.912144 3.73169 0.716839C6.38439 0 17.0401 0 17.0401 0C17.0401 0 27.6929 0 30.3513 0.716839C31.0755 0.910504 31.7363 1.29254 32.2674 1.82457ZM22.4854 12.0014L13.6328 17.1435V6.85938L22.4854 12.0014Z"
        fill="#303337"
      />
    </g>
    <defs>
      <clipPath id="clip0_1394_137889">
        <rect
          width="34.0645"
          height="24"
          fill="white"
          transform="translate(0.0078125)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const GlobeIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1734_79827)">
      <g clipPath="url(#clip1_1734_79827)">
        <path
          d="M17.95 12.5H14.1667C13.7246 12.5 13.3007 12.6756 12.9882 12.9882C12.6756 13.3007 12.5 13.7246 12.5 14.1667V17.95"
          stroke="#303337"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.83203 2.7832V4.16654C5.83203 4.82958 6.09542 5.46546 6.56426 5.9343C7.03311 6.40314 7.66899 6.66654 8.33203 6.66654C8.77406 6.66654 9.19798 6.84213 9.51054 7.15469C9.8231 7.46725 9.9987 7.89118 9.9987 8.3332C9.9987 9.24987 10.7487 9.99987 11.6654 9.99987C12.1074 9.99987 12.5313 9.82427 12.8439 9.51171C13.1564 9.19915 13.332 8.77523 13.332 8.3332C13.332 7.41654 14.082 6.66654 14.9987 6.66654H17.6404"
          stroke="#303337"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.16536 18.291V14.9993C9.16536 14.5573 8.98977 14.1334 8.67721 13.8208C8.36465 13.5083 7.94073 13.3327 7.4987 13.3327C7.05667 13.3327 6.63275 13.1571 6.32019 12.8445C6.00763 12.532 5.83203 12.108 5.83203 11.666V10.8327C5.83203 10.3907 5.65644 9.96673 5.34388 9.65417C5.03132 9.34161 4.60739 9.16602 4.16536 9.16602H1.70703"
          stroke="#303337"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.0013 18.3327C14.6037 18.3327 18.3346 14.6017 18.3346 9.99935C18.3346 5.39698 14.6037 1.66602 10.0013 1.66602C5.39893 1.66602 1.66797 5.39698 1.66797 9.99935C1.66797 14.6017 5.39893 18.3327 10.0013 18.3327Z"
          stroke="#303337"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1734_79827">
        <rect width="20" height="20" fill="white" />
      </clipPath>
      <clipPath id="clip1_1734_79827">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const GlobeIconWhite = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1734_79827)">
      <g clipPath="url(#clip1_1734_79827)">
        <path
          d="M17.95 12.5H14.1667C13.7246 12.5 13.3007 12.6756 12.9882 12.9882C12.6756 13.3007 12.5 13.7246 12.5 14.1667V17.95"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.83203 2.7832V4.16654C5.83203 4.82958 6.09542 5.46546 6.56426 5.9343C7.03311 6.40314 7.66899 6.66654 8.33203 6.66654C8.77406 6.66654 9.19798 6.84213 9.51054 7.15469C9.8231 7.46725 9.9987 7.89118 9.9987 8.3332C9.9987 9.24987 10.7487 9.99987 11.6654 9.99987C12.1074 9.99987 12.5313 9.82427 12.8439 9.51171C13.1564 9.19915 13.332 8.77523 13.332 8.3332C13.332 7.41654 14.082 6.66654 14.9987 6.66654H17.6404"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.16536 18.291V14.9993C9.16536 14.5573 8.98977 14.1334 8.67721 13.8208C8.36465 13.5083 7.94073 13.3327 7.4987 13.3327C7.05667 13.3327 6.63275 13.1571 6.32019 12.8445C6.00763 12.532 5.83203 12.108 5.83203 11.666V10.8327C5.83203 10.3907 5.65644 9.96673 5.34388 9.65417C5.03132 9.34161 4.60739 9.16602 4.16536 9.16602H1.70703"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.0013 18.3327C14.6037 18.3327 18.3346 14.6017 18.3346 9.99935C18.3346 5.39698 14.6037 1.66602 10.0013 1.66602C5.39893 1.66602 1.66797 5.39698 1.66797 9.99935C1.66797 14.6017 5.39893 18.3327 10.0013 18.3327Z"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1734_79827">
        <rect width="20" height="20" fill="white" />
      </clipPath>
      <clipPath id="clip1_1734_79827">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const GlobeSmIcon = ({ extraClass }) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_426_61326)">
      <path
        d="M10.77 7.5H8.5C8.23478 7.5 7.98043 7.60536 7.79289 7.79289C7.60536 7.98043 7.5 8.23478 7.5 8.5V10.77"
        stroke="#303337"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.5 1.66992V2.49992C3.5 2.89775 3.65804 3.27928 3.93934 3.56058C4.22064 3.84189 4.60218 3.99992 5 3.99992C5.26522 3.99992 5.51957 4.10528 5.70711 4.29282C5.89464 4.48035 6 4.73471 6 4.99992C6 5.54992 6.45 5.99992 7 5.99992C7.26522 5.99992 7.51957 5.89456 7.70711 5.70703C7.89464 5.51949 8 5.26514 8 4.99992C8 4.44992 8.45 3.99992 9 3.99992H10.585"
        stroke="#303337"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.49844 10.975V9C5.49844 8.73478 5.39308 8.48043 5.20554 8.29289C5.01801 8.10536 4.76365 8 4.49844 8C4.23322 8 3.97887 7.89464 3.79133 7.70711C3.60379 7.51957 3.49844 7.26522 3.49844 7V6.5C3.49844 6.23478 3.39308 5.98043 3.20554 5.79289C3.01801 5.60536 2.76365 5.5 2.49844 5.5H1.02344"
        stroke="#303337"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11Z"
        stroke="#303337"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_426_61326">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ChevronDown = ({ extraClass = "" }) => (
  <svg
    width="10"
    height="6"
    viewBox="0 0 10 6"
    fill="none"
    className={extraClass}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.828125 1L4.82813 5L8.82813 1"
      stroke="#303337"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ChevronRight = ({ extraClass }) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 8 12"
    fill="none"
    className={extraClass}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.5 1L6.5 6L1.5 11"
      stroke="inherit"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SearchIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 17L21 21M11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11C19 13.2053 18.1077 15.2022 16.6644 16.6493C15.2161 18.1015 13.213 19 11 19Z"
      stroke="#303337"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const HamburgerMenuIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.5 4.16602H17.5M2.5 9.99935H17.5M2.5 15.8327H17.5"
      stroke="#303337"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CloseIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.75781 17.2431L12.0005 12.0005M12.0005 12.0005L17.2431 6.75781M12.0005 12.0005L6.75781 6.75781M12.0005 12.0005L17.2431 17.2431"
      stroke="#303337"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Logotypes
export const PetrotecGroupLogo = () => (
  <svg
    width="123"
    height="91"
    viewBox="0 0 123 91"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_2888_56602)">
      <path
        d="M55.1984 77.7188C54.6646 77.7188 54.4062 78.1654 54.4062 78.682H56.0594C56.0653 78.5613 56.0478 78.4407 56.0077 78.327C55.9676 78.2132 55.9058 78.1086 55.8259 78.0192C55.7459 77.9297 55.6493 77.8571 55.5416 77.8055C55.4339 77.754 55.3173 77.7245 55.1984 77.7188Z"
        fill="#899BA8"
      />
      <path
        d="M93.6622 78.5566C93.526 78.559 93.3918 78.5895 93.2676 78.6462C93.1434 78.7028 93.0319 78.7845 92.9399 78.8863C92.8478 78.9881 92.7772 79.1078 92.7322 79.2382C92.6872 79.3685 92.6688 79.5068 92.6782 79.6446C92.6782 79.9093 92.7818 80.1632 92.9664 80.3504C93.1509 80.5376 93.4012 80.6428 93.6622 80.6428C93.9231 80.6428 94.1734 80.5376 94.358 80.3504C94.5425 80.1632 94.6462 79.9093 94.6462 79.6446C94.6555 79.5068 94.6372 79.3685 94.5922 79.2382C94.5472 79.1078 94.4765 78.9881 94.3844 78.8863C94.2924 78.7845 94.1809 78.7028 94.0567 78.6462C93.9325 78.5895 93.7983 78.559 93.6622 78.5566Z"
        fill="#899BA8"
      />
      <path
        d="M40.4317 78.5566C40.2955 78.559 40.1613 78.5895 40.0371 78.6462C39.913 78.7028 39.8015 78.7845 39.7094 78.8863C39.6174 78.9881 39.5467 79.1078 39.5017 79.2382C39.4567 79.3685 39.4383 79.5068 39.4477 79.6446C39.4477 79.9093 39.5514 80.1632 39.7359 80.3504C39.9204 80.5376 40.1707 80.6428 40.4317 80.6428C40.6927 80.6428 40.9429 80.5376 41.1275 80.3504C41.312 80.1632 41.4157 79.9093 41.4157 79.6446C41.4251 79.5068 41.4067 79.3685 41.3617 79.2382C41.3167 79.1078 41.246 78.9881 41.154 78.8863C41.0619 78.7845 40.9504 78.7028 40.8262 78.6462C40.7021 78.5895 40.5678 78.559 40.4317 78.5566Z"
        fill="#899BA8"
      />
      <path
        d="M19.2335 77.7188C18.6997 77.7188 18.4414 78.1654 18.4414 78.682H20.0945C20.1059 78.4385 20.0217 78.2004 19.8603 78.0199C19.6989 77.8393 19.4735 77.731 19.2335 77.7188Z"
        fill="#899BA8"
      />
      <path
        d="M114.169 83.4456C113.372 83.4456 112.415 82.984 112.014 82.2578H111.93L112.092 83.4456V86.3377H108.545V75.8572H111.93L111.822 77.0326H111.93C112.326 76.1791 113.285 75.69 114.206 75.69C116.252 75.69 117.241 77.6464 117.241 79.5079C117.241 81.2547 116.169 83.4531 114.178 83.4531M107.199 80.0544C107.199 82.4026 105.197 83.4531 103.086 83.4531C100.976 83.4531 98.9732 82.4026 98.9732 80.0544V75.8572H102.484V79.6901C102.484 80.1243 102.511 80.5859 103.086 80.5859C103.662 80.5859 103.687 80.1243 103.687 79.6901V75.8572H107.199V80.0544ZM93.6694 83.4855C91.4013 83.4855 89.266 82.1605 89.266 79.7051C89.266 77.1124 91.2808 75.7449 93.6694 75.7449C96.0581 75.7449 98.0753 77.1124 98.0753 79.7051C98.0753 82.1605 95.94 83.4855 93.6694 83.4855ZM88.9462 79.3507C88.5772 79.1262 88.3189 78.944 87.8663 78.944C86.9462 78.944 86.4788 79.5029 86.4788 80.4262V83.2784H82.9414V75.8572H86.4788L86.3952 76.8554H86.4788C87.1086 75.8747 87.7531 75.6651 88.9388 75.6925L88.9462 79.3507ZM80.5822 81.5716C80.0142 82.1703 79.3319 82.6455 78.577 82.9681C77.8221 83.2907 77.0103 83.454 76.1911 83.4481C73.0423 83.4481 70.4888 81.4518 70.4888 78.0781C70.4888 74.6345 72.9734 72.5659 76.2206 72.5659C78.0189 72.5659 80.4887 73.4742 81.2956 75.2758L77.7852 76.6058C77.6444 76.3506 77.4369 76.1397 77.1857 75.9962C76.9344 75.8527 76.649 75.7821 76.3609 75.7924C75.0152 75.7924 74.2748 76.9677 74.2748 78.2403C74.2748 79.4006 74.9857 80.4861 76.2083 80.4861C76.7987 80.4861 77.554 80.2041 77.7286 79.5628H76.0288V77.0675H81.8319C81.8048 78.7868 81.8048 80.2291 80.5822 81.5591M65.9797 79.1012C65.6336 78.7465 65.1736 78.5296 64.6832 78.4898C64.5405 78.48 64.3973 78.4994 64.2621 78.5469C64.1269 78.5945 64.0026 78.6691 63.8965 78.7665C63.7904 78.8638 63.7047 78.9819 63.6445 79.1135C63.5844 79.2452 63.551 79.3878 63.5463 79.5329C63.5417 79.6779 63.5659 79.8224 63.6176 79.9578C63.6692 80.0931 63.7472 80.2165 63.8469 80.3206C63.9465 80.4247 64.0659 80.5074 64.1977 80.5637C64.3296 80.62 64.4713 80.6488 64.6144 80.6483C65.1629 80.6483 65.5738 80.3713 65.9797 80.0769L65.8296 83.1187C65.2602 83.329 64.6616 83.4469 64.0559 83.4681C61.7017 83.4681 60.0191 82.1156 60.0191 79.6302C60.0191 77.4418 61.5935 75.7275 63.7657 75.7275C64.5184 75.7339 65.2655 75.8602 65.9797 76.1018V79.1012ZM59.532 80.2141H54.4078C54.4078 80.813 54.5013 81.4818 55.2418 81.4818C55.4121 81.4817 55.5769 81.4201 55.7067 81.3081C55.8365 81.1961 55.9228 81.041 55.9502 80.8704H59.3942C58.9244 82.6546 56.9736 83.478 55.3057 83.478C53.0204 83.478 50.9294 82.2778 50.9294 79.735C50.9294 77.2821 52.7891 75.7425 55.0991 75.7425C57.6821 75.7425 59.7214 77.4443 59.5443 80.2191M50.8138 78.7818L49.6354 78.7119V83.3134H46.0733V78.7069L45.2123 78.7768V75.9471L46.0733 76.002V73.5191H49.6256V76.002L50.8039 75.9471L50.8138 78.7818ZM40.4399 83.483C38.1743 83.483 36.0365 82.158 36.0365 79.7026C36.0365 77.1099 38.0513 75.7425 40.4399 75.7425C42.8286 75.7425 44.8458 77.1099 44.8458 79.7026C44.8458 82.158 42.7105 83.483 40.4399 83.483ZM35.8422 79.3956C35.4757 79.1736 35.21 78.9914 34.7623 78.9914C33.8471 78.9914 33.3822 79.5504 33.3822 80.4687V83.3134H29.8423V75.9047H33.3724L33.2863 76.9028H33.3724C33.9997 75.9271 34.6417 75.72 35.8324 75.7474L35.8422 79.3956ZM29.52 78.7768L28.3392 78.7069V83.3084H24.7919V78.7069L23.9309 78.7768V75.9471L24.7919 76.002V73.5191H28.3441V76.002L29.5249 75.9471L29.52 78.7768ZM23.5668 80.2141H18.45C18.45 80.813 18.5435 81.4818 19.2839 81.4818C19.4546 81.4817 19.6197 81.4203 19.7499 81.3083C19.8801 81.1964 19.9669 81.0412 19.9949 80.8704H23.4389C22.9739 82.6546 21.0158 83.478 19.3479 83.478C17.0675 83.478 14.974 82.2778 14.974 79.735C14.974 77.2821 16.8313 75.7425 19.156 75.7425C21.739 75.7425 23.7808 77.4443 23.6012 80.2191M11.3283 80.1492H9.38244V83.3134H5.77116V72.7954H10.519C12.9224 72.7954 14.701 74.0431 14.701 76.6558C14.701 78.8043 13.3873 80.1492 11.2939 80.1492M0 90.1032H123V67.373H0V90.1032Z"
        fill="#899BA8"
      />
      <path
        d="M112.827 78.5078C112.234 78.5078 111.922 79.0069 111.922 79.5584C111.922 80.1098 112.234 80.6214 112.827 80.6214C113.376 80.6214 113.745 80.0325 113.745 79.5284C113.751 79.2711 113.659 79.0213 113.488 78.8311C113.317 78.6409 113.08 78.5251 112.827 78.5078Z"
        fill="#899BA8"
      />
      <path
        d="M98.7852 61.6907H115.715L121.717 48.5801L102.859 51.8565L98.7852 61.6907Z"
        fill="#899BA8"
      />
      <path
        d="M100.178 51.9387L100.429 37.4707L84.5078 48.288L84.712 58.9607L100.178 51.9387Z"
        fill="#899BA8"
      />
      <path
        d="M104.202 25.2431L98.6623 11.918L88.4336 28.4048L92.8764 38.0718L104.202 25.2431Z"
        fill="#899BA8"
      />
      <path
        d="M83.5666 29.603L74.4498 18.5137L69.3945 37.3311L76.4129 45.2514L83.5666 29.603Z"
        fill="#899BA8"
      />
      <path
        d="M67.6748 23.3864V6.1211L54.8164 0L58.0316 19.2317L67.6748 23.3864Z"
        fill="#899BA8"
      />
      <path
        d="M61.7099 41.1983L55.0974 25.3079L40.918 24.7988L51.245 41.2207L61.7099 41.1983Z"
        fill="#899BA8"
      />
      <path
        d="M39.9997 31.9255L29.5766 18.3184L15.7539 21.5698L29.894 34.7078L39.9997 31.9255Z"
        fill="#899BA8"
      />
      <path
        d="M20.5469 46.5056L38.5984 52.9635L46.832 46.3733L32.0277 38.0039L20.5469 46.5056Z"
        fill="#899BA8"
      />
      <path
        d="M25.8023 52.8582L9.13088 49.8613L0.988281 61.7093L20.1197 61.8216L25.8023 52.8582Z"
        fill="#899BA8"
      />
      <path
        d="M7.30469 74.4199L10.1534 78.9465L13.0414 78.9415L11.2161 74.5597L7.30469 74.4199Z"
        fill="#899BA8"
      />
    </g>
    <defs>
      <clipPath id="clip0_2888_56602">
        <rect width="123" height="90.1047" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const PetrotecLogo = () => (
  <svg
    width="123"
    height="89"
    viewBox="0 0 123 89"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1367_74992)">
      <path
        d="M66.6241 78.6016C66.4708 78.6033 66.3195 78.6367 66.1794 78.6995C66.0393 78.7623 65.9135 78.8532 65.8096 78.9668C65.7057 79.0804 65.6259 79.2141 65.5752 79.3599C65.5244 79.5056 65.5038 79.6602 65.5145 79.8143C65.504 79.9672 65.5249 80.1206 65.5758 80.2651C65.6267 80.4095 65.7065 80.5418 65.8104 80.6539C65.9142 80.7659 66.0398 80.8552 66.1793 80.9163C66.3188 80.9774 66.4693 81.0089 66.6215 81.0089C66.7736 81.0089 66.9241 80.9774 67.0636 80.9163C67.2032 80.8552 67.3287 80.7659 67.4326 80.6539C67.5364 80.5418 67.6162 80.4095 67.6671 80.2651C67.718 80.1206 67.7389 79.9672 67.7285 79.8143C67.7391 79.6607 67.7187 79.5065 67.6682 79.3611C67.6178 79.2157 67.5385 79.0822 67.4351 78.9687C67.3318 78.8552 67.2066 78.7641 67.0671 78.701C66.9277 78.6379 66.7769 78.6041 66.6241 78.6016Z"
        fill="#2EA373"
      />
      <path
        d="M42.7882 77.6738C42.1863 77.6738 41.8984 78.1695 41.8984 78.7284H43.7565C43.7651 78.4597 43.6682 78.1984 43.487 78.0011C43.3058 77.8037 43.0548 77.6862 42.7882 77.6738Z"
        fill="#2EA373"
      />
      <path
        d="M83.2231 77.6738C82.6212 77.6738 82.3281 78.1695 82.3281 78.7284H84.1915C84.2 78.4597 84.1032 78.1984 83.922 78.0011C83.7408 77.8037 83.4897 77.6862 83.2231 77.6738Z"
        fill="#2EA373"
      />
      <path
        d="M0 66.5488V89.0005H123V66.5488H0ZM33.8695 80.3689H31.7131V83.8859H27.6567V72.2066H32.9745C35.6805 72.2066 37.6851 73.6039 37.6851 76.4986C37.6851 78.882 36.2196 80.3689 33.8695 80.3689ZM47.6612 80.448H41.9037C41.9037 81.1124 42.0084 81.8558 42.8406 81.8558C43.0275 81.855 43.2084 81.7897 43.3532 81.6707C43.498 81.5517 43.5979 81.3862 43.6362 81.202H47.4937C46.9703 83.1846 44.772 84.0968 42.893 84.0968C40.3283 84.0968 37.9782 82.768 37.9782 79.9313C37.9782 77.2052 40.0718 75.5021 42.6889 75.5021C45.5676 75.4757 47.8601 77.3687 47.6612 80.448ZM54.3555 78.8661L53.0366 78.7871V83.8964H49.0377V78.7765L48.0694 78.8556V75.6919L49.0377 75.7552V72.9975H53.0366V75.7552L54.3555 75.6919V78.8661ZM61.4477 79.5411C61.0965 79.2727 60.6735 79.1166 60.2334 79.0929C59.1866 79.0929 58.6631 79.7151 58.6631 80.738V83.9017H54.6957V75.6761H58.6631L58.5689 76.7781H58.6631C59.3697 75.6972 60.092 75.4599 61.4267 75.4915L61.4477 79.5411ZM66.6241 84.081C64.0699 84.081 61.6727 82.6099 61.6727 79.8627C61.6727 76.9838 63.9338 75.4652 66.6241 75.4652C69.3144 75.4652 71.5703 76.9838 71.5703 79.8627C71.5703 82.5993 69.1731 84.0704 66.6241 84.0704V84.081ZM78.2803 78.8661L76.9404 78.7765V83.8859H72.9625V78.7765L71.9943 78.8556V75.6919L72.9625 75.7552V72.9975H76.9404V75.7552L78.2646 75.6919L78.2803 78.8661ZM88.0942 80.448H82.3367C82.3367 81.1124 82.4466 81.8558 83.2788 81.8558C83.47 81.8559 83.6549 81.7875 83.8006 81.6629C83.9464 81.5383 84.0434 81.3656 84.0744 81.1756H87.9319C87.4085 83.1582 85.2102 84.0704 83.3312 84.0704C80.7665 84.0704 78.4164 82.7417 78.4164 79.9049C78.4164 77.1788 80.51 75.4757 83.1009 75.4757C86.0005 75.4757 88.2931 77.3687 88.0942 80.448ZM95.3433 79.2247C94.9536 78.8285 94.4351 78.587 93.883 78.5445C93.7212 78.5297 93.5581 78.5484 93.4037 78.5994C93.2493 78.6503 93.1068 78.7325 92.9851 78.8409C92.8633 78.9493 92.7648 79.0816 92.6956 79.2297C92.6264 79.3778 92.5879 79.5386 92.5825 79.7022C92.5772 79.8658 92.6051 80.0288 92.6644 80.1811C92.7238 80.3335 92.8135 80.4721 92.9279 80.5883C93.0423 80.7045 93.179 80.796 93.3298 80.8571C93.4805 80.9182 93.6421 80.9476 93.8045 80.9436C94.3714 80.9038 94.9107 80.682 95.3433 80.3109L95.1758 83.6855C94.533 83.9165 93.8586 84.0464 93.1764 84.0704C90.5332 84.0704 88.6385 82.5677 88.6385 79.8153C88.6223 79.249 88.7195 78.6852 88.9244 78.1576C89.1292 77.6299 89.4374 77.1493 89.8306 76.7443C90.2239 76.3393 90.694 76.0182 91.2131 75.8003C91.7322 75.5823 92.2896 75.4719 92.8519 75.4757C93.6986 75.4855 94.5389 75.626 95.3433 75.8923V79.2247Z"
        fill="#2EA373"
      />
      <path
        d="M32.5808 79.04L29.3828 74.0098L33.7742 74.168L35.8259 79.0295L32.5808 79.04Z"
        fill="#2EA373"
      />
      <path
        d="M103 51.2199L121.864 47.9824L115.86 60.9378H98.9336L103 51.2199Z"
        fill="#2EA373"
      />
      <path
        d="M84.6562 47.6978L100.573 37.0098L100.322 51.3044L84.8604 58.2382L84.6562 47.6978Z"
        fill="#2EA373"
      />
      <path
        d="M88.582 28.0559L98.8093 11.7734L104.347 24.9291L93.0205 37.605L88.582 28.0559Z"
        fill="#2EA373"
      />
      <path
        d="M69.5391 36.8724L74.5951 18.291L83.7129 29.2427L76.5579 44.6973L69.5391 36.8724Z"
        fill="#2EA373"
      />
      <path
        d="M58.1746 18.998L54.9609 0L67.8158 6.04793V23.1002L58.1746 18.998Z"
        fill="#2EA373"
      />
      <path
        d="M51.3932 40.7153L41.0664 24.4961L55.2454 24.997L61.8613 40.6942L51.3932 40.7153Z"
        fill="#2EA373"
      />
      <path
        d="M30.0447 34.2852L15.9023 21.3088L29.7255 18.0977L40.1464 31.5328L30.0447 34.2852Z"
        fill="#2EA373"
      />
      <path
        d="M38.7436 52.3168L20.6914 45.9367L32.1749 37.5371L46.982 45.8102L38.7436 52.3168Z"
        fill="#2EA373"
      />
      <path
        d="M20.2671 61.0592L1.13672 60.9537L9.27565 49.248L25.9461 52.2061L20.2671 61.0592Z"
        fill="#2EA373"
      />
    </g>
    <defs>
      <clipPath id="clip0_1367_74992">
        <rect width="123" height="89" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const PetroassistLogo = () => (
  <svg
    width="125"
    height="89"
    viewBox="0 0 125 89"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1367_74670)">
      <path
        d="M103.719 51.2216L99.6133 60.9381H116.682L122.73 47.9863L103.719 51.2216Z"
        fill="#E25E17"
      />
      <path
        d="M85.2148 47.696L101.27 37.0137L101.011 51.3007L85.4154 58.2411L85.2148 47.696Z"
        fill="#E25E17"
      />
      <path
        d="M89.1758 28.0575L99.4887 11.7754L105.073 24.933L93.6514 37.6051L89.1758 28.0575Z"
        fill="#E25E17"
      />
      <path
        d="M69.9727 36.8756L75.071 18.2871L84.265 29.2386L77.0502 44.6974L69.9727 36.8756Z"
        fill="#E25E17"
      />
      <path
        d="M58.514 18.9949L68.2358 23.1011V6.04311L55.2734 0L58.514 18.9949Z"
        fill="#E25E17"
      />
      <path
        d="M51.671 40.7182L41.2578 24.4941L55.5554 25.0008L62.2266 40.6971L51.671 40.7182Z"
        fill="#E25E17"
      />
      <path
        d="M30.1435 34.2795L15.8828 21.3066L29.8268 18.0977L40.335 31.535L30.1435 34.2795Z"
        fill="#E25E17"
      />
      <path
        d="M38.9206 52.3137L20.7227 45.9328L32.2969 37.541L47.2226 45.8061L38.9206 52.3137Z"
        fill="#E25E17"
      />
      <path
        d="M0.996094 60.9543L20.2813 61.0651L26.013 52.2089L9.20311 49.248L0.996094 60.9543Z"
        fill="#E25E17"
      />
      <path
        d="M32.4947 77.8105C31.9036 77.8105 31.6133 78.2961 31.6133 78.8661H33.45C33.4571 78.734 33.4379 78.6017 33.3937 78.477C33.3494 78.3523 33.2809 78.2375 33.1921 78.1394C33.1033 78.0413 32.996 77.9617 32.8763 77.9053C32.7566 77.8488 32.6269 77.8166 32.4947 77.8105Z"
        fill="#E25E17"
      />
      <path
        d="M0 66.5488V89.0007H124.029V66.5488H0ZM23.6922 80.4506H21.581V83.8865H17.5699V72.4653H22.8477C25.5183 72.4653 27.4922 73.8322 27.4922 76.6611C27.4711 78.9939 26.0144 80.4506 23.6922 80.4506ZM37.3037 80.5245H31.6142C31.6142 81.179 31.7197 81.902 32.5378 81.902C32.7273 81.9034 32.911 81.8372 33.0561 81.7153C33.2012 81.5935 33.2981 81.4239 33.3295 81.237H37.1348C36.607 83.174 34.4537 84.0712 32.6011 84.0712C30.0678 84.0712 27.7455 82.7676 27.7455 79.9967C27.7455 77.3578 29.8092 75.6636 32.3742 75.6636C35.2401 75.6636 37.499 77.5109 37.3037 80.5245ZM43.9062 78.9676L42.6026 78.8884V83.8865H38.6601V78.8884L37.7048 78.9676V75.8906L38.6601 75.9486V73.2517H42.6026V75.9486L43.9062 75.8906V78.9676ZM50.9046 79.6326C50.56 79.3665 50.1416 79.2135 49.7066 79.1945C48.6932 79.1945 48.176 79.8015 48.176 80.7779V83.8654H44.2651V75.8431H48.176L48.0863 76.8986H48.176C48.8727 75.8431 49.5852 75.6109 50.9046 75.6425V79.6326ZM56.0083 84.0712C53.4908 84.0712 51.1263 82.6304 51.1263 79.9651C51.1263 77.1467 53.3536 75.6636 56.0083 75.6636C58.6631 75.6636 60.8903 77.1467 60.8903 79.9651C60.8903 82.6304 58.5258 84.0712 56.0083 84.0712ZM71.1346 83.8865H67.2976L67.419 82.8309H67.3292C66.6167 83.5857 65.9781 84.0712 64.8751 84.0712C62.69 84.0712 61.4761 81.8598 61.4761 79.9017C61.4761 77.9437 62.7059 75.6795 64.9806 75.6795C65.4354 75.6594 65.8881 75.7526 66.298 75.9506C66.708 76.1487 67.0623 76.4454 67.3292 76.8142H67.419L67.2976 75.8589H71.1346V83.8865ZM75.2988 84.0712C74.0192 84.0254 72.7623 83.7202 71.6043 83.174L72.6071 80.7515L72.8446 80.9045C73.442 81.3122 74.131 81.5661 74.8502 81.6434C75.1088 81.6434 75.4254 81.5115 75.4254 81.2054C75.4254 80.7673 74.9557 80.7515 74.639 80.6776C73.3301 80.4981 72.1215 79.9703 72.1215 78.4556C72.1215 76.4395 74.1482 75.6372 75.8793 75.6372C76.9598 75.6161 78.0301 75.8494 79.0038 76.3181L78.0485 78.5453C77.5285 78.1445 76.8991 77.9108 76.2435 77.875C76.0007 77.875 75.684 77.9542 75.684 78.2392C75.684 78.6351 76.1063 78.6667 76.6552 78.767C78.0485 78.9939 79.1832 79.4795 79.1832 81.0998C79.1938 83.2057 77.1196 84.0712 75.2988 84.0712ZM82.9516 84.0712C81.6722 84.0241 80.4156 83.7189 79.2571 83.174L80.2599 80.7515L80.5027 80.9045C81.0978 81.313 81.7852 81.5669 82.503 81.6434C82.7616 81.6434 83.0836 81.5115 83.0836 81.2054C83.0836 80.7673 82.6086 80.7515 82.2919 80.6776C80.9883 80.4981 79.7744 79.9703 79.7744 78.4556C79.7744 76.4395 81.8063 75.6372 83.5375 75.6372C84.6178 75.6173 85.6878 75.8505 86.6619 76.3181L85.7014 78.5453C85.1846 78.157 84.5631 77.9327 83.9175 77.9014C83.6747 77.9014 83.3527 77.9806 83.3527 78.2656C83.3527 78.6614 83.7802 78.6931 84.3239 78.7934C85.7172 79.0203 86.8572 79.5059 86.8572 81.1262C86.8467 83.2057 84.7672 84.0712 82.9516 84.0712ZM91.7075 83.8865H87.7967V75.8431H91.7075V83.8865ZM89.7495 75.252C88.6253 75.252 87.5961 74.6767 87.5961 73.3625C87.5961 72.1908 88.525 71.4783 89.7495 71.4783C90.9739 71.4783 91.9028 72.1908 91.9028 73.3625C91.9028 74.6767 90.8736 75.252 89.7495 75.252ZM96.0828 84.0712C94.8033 84.0254 93.5464 83.7202 92.3884 83.174L93.4175 80.7515L93.6603 80.9045C94.2554 81.313 94.9429 81.5669 95.6606 81.6434C95.9192 81.6434 96.2359 81.5115 96.2359 81.2054C96.2359 80.7673 95.7662 80.7515 95.4495 80.6776C94.1459 80.4981 92.932 79.9703 92.932 78.4556C92.932 76.4395 94.964 75.6372 96.6951 75.6372C97.7737 75.6172 98.8421 75.8503 99.8143 76.3181L98.859 78.5453C98.3393 78.1439 97.7097 77.9101 97.054 77.875C96.8165 77.875 96.4945 77.9542 96.4945 78.2392C96.4945 78.6351 96.9167 78.6667 97.4656 78.767C98.859 78.9939 99.999 79.4795 99.999 81.0998C100.01 83.2057 97.9301 84.0712 96.1092 84.0712H96.0828ZM106.433 78.9676L105.129 78.8884V83.8865H101.187V78.8884L100.231 78.9676V75.8906L101.187 75.9486V73.2517H105.129V75.9486L106.433 75.8906V78.9676Z"
        fill="#E25E17"
      />
      <path
        d="M56.0087 78.7246C55.8585 78.7265 55.7103 78.7588 55.573 78.8197C55.4357 78.8806 55.3123 78.9688 55.2101 79.0788C55.1079 79.1889 55.0292 79.3186 54.9787 79.46C54.9281 79.6014 54.9069 79.7517 54.9162 79.9016C54.9162 80.1913 55.0313 80.4692 55.2362 80.6741C55.4411 80.879 55.719 80.9941 56.0087 80.9941C56.2985 80.9941 56.5763 80.879 56.7812 80.6741C56.9861 80.4692 57.1012 80.1913 57.1012 79.9016C57.1113 79.7515 57.0906 79.601 57.0403 79.4592C56.9901 79.3174 56.9114 79.1874 56.8091 79.0772C56.7068 78.967 56.583 78.8788 56.4453 78.8182C56.3077 78.7576 56.1591 78.7257 56.0087 78.7246Z"
        fill="#E25E17"
      />
      <path
        d="M66.3741 78.7193C66.2345 78.7247 66.0974 78.7578 65.9707 78.8166C65.8439 78.8754 65.7302 78.9587 65.6359 79.0618C65.5416 79.1649 65.4688 79.2857 65.4216 79.4171C65.3743 79.5486 65.3536 79.6881 65.3607 79.8276C65.3607 80.4663 65.6616 81.0099 66.3741 81.0099C67.0866 81.0099 67.4296 80.4188 67.4296 79.8012C67.4378 79.6593 67.4163 79.5172 67.3664 79.384C67.3166 79.2508 67.2396 79.1294 67.1403 79.0276C67.041 78.9259 66.9216 78.8459 66.7897 78.7928C66.6577 78.7397 66.5162 78.7147 66.3741 78.7193Z"
        fill="#E25E17"
      />
      <path
        d="M22.3082 79.2837L19.0781 74.2539L23.5115 74.4122L25.5804 79.2784L22.3082 79.2837Z"
        fill="#E25E17"
      />
    </g>
    <defs>
      <clipPath id="clip0_1367_74670">
        <rect width="124.029" height="89" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const FullLogotypeGroup = ({ extraClass = "" }) => (
  <svg
    width="199"
    height="25"
    viewBox="0 0 199 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={extraClass}
  >
    <path
      d="M42.4056 11.2783L40.3064 11.1521V19.4984H33.9524V11.1521L32.418 11.2783V6.14434L33.9524 6.24139V1.73828H40.3064V6.24139L42.4056 6.14434V11.2783Z"
      fill="#899BA8"
    />
    <path
      d="M53.6553 12.3841C53.1113 11.9535 52.4567 11.697 51.7726 11.6465C51.4296 11.6153 51.0841 11.6643 50.762 11.7899C50.4399 11.9156 50.1494 12.1146 49.9123 12.3721C49.6752 12.6296 49.4976 12.939 49.3926 13.2771C49.2877 13.6153 49.2582 13.9735 49.3063 14.3251V19.4882H42.9805V6.06619H49.2781L49.1274 7.8616H49.2781C50.3983 6.0856 51.5467 5.7071 53.6553 5.76533V12.3841Z"
      fill="#899BA8"
    />
    <path
      d="M80.4001 11.2783L78.3009 11.1521V19.4984H71.9563V11.1521L70.4219 11.2783V6.14434L71.9563 6.24139V1.73828H78.3009V6.24139L80.4001 6.14434V11.2783Z"
      fill="#899BA8"
    />
    <path
      d="M107.502 11.8807C106.877 11.2431 106.054 10.8517 105.177 10.7743C104.93 10.766 104.684 10.808 104.452 10.8979C104.221 10.9878 104.009 11.1238 103.828 11.2982C103.648 11.4726 103.502 11.6819 103.4 11.9142C103.298 12.1465 103.241 12.3973 103.233 12.6522C103.225 12.9071 103.266 13.1611 103.353 13.3998C103.44 13.6385 103.572 13.8571 103.742 14.0432C103.911 14.2293 104.114 14.3792 104.339 14.4844C104.564 14.5896 104.808 14.648 105.055 14.6563C105.958 14.5919 106.817 14.2276 107.502 13.6179L107.229 19.1303C106.211 19.5137 105.141 19.7298 104.057 19.7708C99.8587 19.7708 96.8558 17.3154 96.8558 12.8026C96.8237 11.8812 96.9739 10.9628 97.2972 10.1031C97.6205 9.2435 98.1102 8.46071 98.7364 7.80245C99.3625 7.14418 100.112 6.6242 100.939 6.27419C101.767 5.92418 102.655 5.75145 103.549 5.76653C104.893 5.77512 106.228 6.00444 107.502 6.44588V11.8807Z"
      fill="#899BA8"
    />
    <path
      d="M133.568 16.3432C132.555 17.4287 131.338 18.2904 129.992 18.876C128.645 19.4616 127.197 19.7588 125.736 19.7496C120.088 19.7496 115.551 16.1394 115.551 10.0446C115.551 3.94992 119.985 0 125.783 0C128.993 0 133.399 1.64984 134.848 4.92042L128.579 7.30784C128.326 6.84348 127.955 6.45951 127.505 6.19771C127.055 5.9359 126.544 5.80629 126.028 5.82298C123.628 5.82298 122.31 7.94837 122.31 10.2581C122.31 12.3641 123.58 14.3439 125.755 14.3439C126.809 14.3439 128.165 13.8393 128.475 12.6747H125.444V8.17158H135.799C135.752 11.2966 135.752 13.9072 133.568 16.3432Z"
      fill="#899BA8"
    />
    <path
      d="M148.505 12.3062C147.945 11.8653 147.269 11.6083 146.566 11.5686C146.221 11.539 145.874 11.5897 145.551 11.717C145.228 11.8443 144.936 12.0449 144.699 12.304C144.461 12.5631 144.283 12.8741 144.177 13.2138C144.072 13.5535 144.042 13.9133 144.09 14.2666V19.4102H137.773V5.96883H144.09L143.949 7.76425H144.09C145.219 5.98824 146.377 5.60974 148.505 5.65827V12.3062Z"
      fill="#899BA8"
    />
    <path
      d="M181.077 13.5871C181.077 17.8573 177.5 19.7594 173.725 19.7594C169.951 19.7594 166.383 17.8185 166.383 13.5871V5.95898H172.652V12.9174C172.652 13.7035 172.699 14.5382 173.725 14.5382C174.751 14.5382 174.808 13.7035 174.808 12.9174V5.95898H181.077V13.5871Z"
      fill="#899BA8"
    />
    <path
      d="M88.0515 5.76562C83.9284 5.76562 80.6055 8.55095 80.6055 12.9958C80.6055 17.6251 84.3708 19.7893 88.4186 19.7893C91.3933 19.7893 94.8856 18.2947 95.714 15.0533H89.5859C89.5371 15.3628 89.3837 15.6446 89.1529 15.8488C88.922 16.053 88.6286 16.1666 88.3245 16.1693C86.9972 16.1693 86.8277 14.9562 86.8277 13.8596H96.0153C96.3071 8.85181 92.6641 5.76562 88.0515 5.76562ZM86.8277 11.1034C86.8277 10.1329 87.2984 9.35646 88.2492 9.35646C88.6771 9.37907 89.0789 9.57563 89.3665 9.90306C89.6541 10.2305 89.8041 10.6621 89.7836 11.1034H86.8277Z"
      fill="#899BA8"
    />
    <path
      d="M156.923 5.76562C152.658 5.76562 149.062 8.24039 149.062 12.9473C149.062 17.4019 152.875 19.8087 156.923 19.8087C160.97 19.8087 164.783 17.4019 164.783 12.9473C164.783 8.24039 161.196 5.76562 156.923 5.76562ZM156.923 14.6942C156.689 14.6955 156.457 14.6486 156.241 14.556C156.025 14.4634 155.829 14.3272 155.665 14.1553C155.501 13.9834 155.372 13.7794 155.286 13.5552C155.199 13.3311 155.157 13.0914 155.162 12.8503C155.137 12.5962 155.163 12.3394 155.24 12.0965C155.317 11.8537 155.443 11.6301 155.608 11.4404C155.774 11.2507 155.977 11.099 156.204 10.9952C156.43 10.8914 156.675 10.8378 156.923 10.8378C157.17 10.8378 157.416 10.8914 157.642 10.9952C157.868 11.099 158.071 11.2507 158.237 11.4404C158.403 11.6301 158.528 11.8537 158.605 12.0965C158.682 12.3394 158.709 12.5962 158.683 12.8503C158.688 13.0914 158.646 13.3311 158.56 13.5552C158.474 13.7794 158.345 13.9834 158.18 14.1553C158.016 14.3272 157.82 14.4634 157.604 14.556C157.388 14.6486 157.157 14.6955 156.923 14.6942Z"
      fill="#899BA8"
    />
    <path
      d="M61.8837 5.76562C57.61 5.76562 54.0234 8.24039 54.0234 12.9473C54.0234 17.4019 57.7888 19.8087 61.8837 19.8087C65.9785 19.8087 69.7439 17.4019 69.7439 12.9473C69.7439 8.24039 66.1573 5.76562 61.8837 5.76562ZM61.8837 14.6942C61.6497 14.6955 61.4179 14.6486 61.2019 14.556C60.9859 14.4634 60.79 14.3272 60.6259 14.1553C60.4619 13.9834 60.3328 13.7794 60.2465 13.5552C60.1602 13.3311 60.1183 13.0914 60.1233 12.8503C60.0978 12.5962 60.1243 12.3394 60.2012 12.0965C60.278 11.8537 60.4035 11.6301 60.5694 11.4404C60.7353 11.2507 60.9381 11.099 61.1645 10.9952C61.3909 10.8914 61.6359 10.8378 61.8837 10.8378C62.1314 10.8378 62.3764 10.8914 62.6028 10.9952C62.8292 11.099 63.032 11.2507 63.1979 11.4404C63.3638 11.6301 63.4893 11.8537 63.5661 12.0965C63.643 12.3394 63.6695 12.5962 63.644 12.8503C63.649 13.0914 63.6071 13.3311 63.5208 13.5552C63.4345 13.7794 63.3054 13.9834 63.1414 14.1553C62.9773 14.3272 62.7814 14.4634 62.5654 14.556C62.3494 14.6486 62.1176 14.6955 61.8837 14.6942Z"
      fill="#899BA8"
    />
    <path
      d="M23.8367 5.76562C19.7136 5.76562 16.3906 8.55095 16.3906 12.9958C16.3906 17.6251 20.156 19.7893 24.2038 19.7893C27.1878 19.7893 30.6708 18.2947 31.4992 15.0533H25.4181C25.3711 15.3636 25.2182 15.6465 24.987 15.8511C24.7558 16.0556 24.4614 16.1685 24.1567 16.1693C22.8388 16.1693 22.6694 14.9562 22.6694 13.8596H31.8192C32.0922 8.85181 28.4492 5.76562 23.8367 5.76562ZM22.5941 11.1034C22.5941 10.1329 23.0553 9.35646 24.0061 9.35646C24.434 9.37907 24.8358 9.57563 25.1234 9.90306C25.411 10.2305 25.561 10.6621 25.5405 11.1034H22.5941Z"
      fill="#899BA8"
    />
    <path
      d="M193.587 5.65911C192.758 5.64222 191.94 5.86047 191.223 6.29004C190.506 6.7196 189.917 7.34399 189.521 8.09506H189.323L189.521 5.96967H183.496V25.0011H189.813V19.7507L189.521 17.5962H189.69C190.114 18.2502 190.687 18.7881 191.357 19.1634C192.028 19.5387 192.777 19.7403 193.54 19.7507C197.089 19.7507 199 15.762 199 12.5885C199 9.21113 197.24 5.65911 193.587 5.65911ZM191.14 14.6168C190.906 14.6091 190.677 14.5514 190.467 14.4475C190.256 14.3436 190.069 14.1957 189.916 14.0132C189.764 13.8307 189.65 13.6176 189.582 13.3874C189.514 13.1571 189.493 12.9148 189.521 12.6758C189.493 12.4368 189.514 12.1945 189.582 11.9642C189.65 11.734 189.764 11.5209 189.916 11.3384C190.069 11.1559 190.256 11.008 190.467 10.9041C190.677 10.8002 190.906 10.7425 191.14 10.7348C191.598 10.7648 192.026 10.9789 192.332 11.331C192.638 11.6831 192.798 12.1451 192.778 12.6176C192.796 13.1014 192.638 13.5747 192.335 13.9446C192.032 14.3145 191.606 14.5542 191.14 14.6168Z"
      fill="#899BA8"
    />
    <path
      d="M8.47209 0.417969H0V19.4979H6.4482V13.7526H9.86528C13.6306 13.7526 15.9464 11.3263 15.9464 7.42495C15.9464 2.69864 12.7646 0.417969 8.47209 0.417969ZM6.57881 10.3349L2.73931 3.36828L9.72408 3.62061L11.728 10.3252L6.57881 10.3349Z"
      fill="#899BA8"
    />
  </svg>
);

export const FullLogotypePetrotec = ({ extraClass = "" }) => (
  <svg
    width="106"
    height="19"
    viewBox="0 0 106 19"
    fill="none"
    className={extraClass}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M41.5564 10.6411L39.4994 10.5175V18.6959H33.2731V10.5175L31.7695 10.6411V5.61043L33.2731 5.70553V1.29297H39.4994V5.70553L41.5564 5.61043V10.6411Z"
      fill="#2EA373"
    />
    <path
      d="M52.5735 11.7255C52.0404 11.3036 51.399 11.0522 50.7286 11.0028C50.3925 10.9722 50.054 11.0202 49.7383 11.1433C49.4227 11.2664 49.1381 11.4614 48.9058 11.7137C48.6734 11.9661 48.4993 12.2692 48.3965 12.6006C48.2937 12.932 48.2648 13.283 48.3119 13.6275V18.6867H42.1133V5.53463H48.2842L48.1366 7.29395H48.2842C49.3819 5.55365 50.5073 5.18277 52.5735 5.23983V11.7255Z"
      fill="#2EA373"
    />
    <path
      d="M78.7854 10.6411L76.7284 10.5175V18.6959H70.5114V10.5175L69.0078 10.6411V5.61043L70.5114 5.70553V1.29297H76.7284V5.70553L78.7854 5.61043V10.6411Z"
      fill="#2EA373"
    />
    <path
      d="M105.339 11.2323C104.726 10.6076 103.92 10.224 103.061 10.1482C102.818 10.1401 102.577 10.1812 102.35 10.2693C102.123 10.3574 101.915 10.4907 101.739 10.6616C101.562 10.8324 101.419 11.0375 101.319 11.2652C101.219 11.4928 101.164 11.7386 101.156 11.9883C101.148 12.2381 101.188 12.487 101.273 12.7209C101.359 12.9548 101.488 13.169 101.654 13.3513C101.82 13.5337 102.019 13.6806 102.239 13.7837C102.46 13.8868 102.698 13.944 102.941 13.9521C103.826 13.8891 104.667 13.532 105.339 12.9346L105.072 18.3361C104.074 18.7119 103.025 18.9236 101.963 18.9638C97.849 18.9638 94.9065 16.5578 94.9065 12.1357C94.8751 11.2329 95.0223 10.3329 95.3391 9.49052C95.6559 8.64818 96.1357 7.88113 96.7492 7.2361C97.3628 6.59107 98.0973 6.08155 98.908 5.73857C99.7187 5.3956 100.589 5.22635 101.465 5.24113C102.782 5.24954 104.09 5.47425 105.339 5.90681V11.2323Z"
      fill="#2EA373"
    />
    <path
      d="M86.2846 5.24023C82.2444 5.24023 78.9883 7.96955 78.9883 12.3251C78.9883 16.8612 82.6779 18.9819 86.6443 18.9819C89.5592 18.9819 92.9813 17.5174 93.793 14.3411H87.7881C87.7403 14.6444 87.59 14.9205 87.3638 15.1206C87.1376 15.3208 86.8501 15.432 86.5521 15.4348C85.2515 15.4348 85.0854 14.246 85.0854 13.1714H94.0882C94.3742 8.26436 90.8044 5.24023 86.2846 5.24023ZM85.0854 10.4706C85.0854 9.51965 85.5467 8.75887 86.4783 8.75887C86.8976 8.78102 87.2913 8.97363 87.5731 9.29448C87.8549 9.61533 88.0019 10.0383 87.9818 10.4706H85.0854Z"
      fill="#2EA373"
    />
    <path
      d="M60.6397 5.24023C56.4519 5.24023 52.9375 7.66524 52.9375 12.2775C52.9375 16.6425 56.6272 19.0009 60.6397 19.0009C64.6522 19.0009 68.3418 16.6425 68.3418 12.2775C68.3418 7.66524 64.8274 5.24023 60.6397 5.24023ZM60.6397 13.9893C60.4104 13.9906 60.1833 13.9446 59.9716 13.8539C59.7599 13.7632 59.568 13.6297 59.4072 13.4612C59.2465 13.2928 59.12 13.0929 59.0354 12.8732C58.9509 12.6536 58.9098 12.4187 58.9147 12.1824C58.8897 11.9334 58.9157 11.6818 58.991 11.4438C59.0663 11.2058 59.1892 10.9868 59.3518 10.8009C59.5144 10.615 59.7131 10.4664 59.9349 10.3647C60.1568 10.263 60.3969 10.2104 60.6397 10.2104C60.8825 10.2104 61.1226 10.263 61.3444 10.3647C61.5662 10.4664 61.7649 10.615 61.9275 10.8009C62.0901 10.9868 62.213 11.2058 62.2883 11.4438C62.3636 11.6818 62.3896 11.9334 62.3646 12.1824C62.3695 12.4187 62.3285 12.6536 62.2439 12.8732C62.1593 13.0929 62.0329 13.2928 61.8721 13.4612C61.7113 13.6297 61.5194 13.7632 61.3077 13.8539C61.096 13.9446 60.8689 13.9906 60.6397 13.9893Z"
      fill="#2EA373"
    />
    <path
      d="M23.3549 5.24023C19.3147 5.24023 16.0586 7.96955 16.0586 12.3251C16.0586 16.8612 19.7483 18.9819 23.7146 18.9819C26.6387 18.9819 30.0516 17.5174 30.8634 14.3411H24.9046C24.8585 14.6452 24.7087 14.9224 24.4821 15.1229C24.2555 15.3233 23.9671 15.4339 23.6685 15.4348C22.3771 15.4348 22.2111 14.246 22.2111 13.1714H31.177C31.4445 8.26436 27.8747 5.24023 23.3549 5.24023ZM22.1373 10.4706C22.1373 9.51965 22.5893 8.75887 23.5209 8.75887C23.9402 8.78102 24.3339 8.97363 24.6158 9.29448C24.8976 9.61533 25.0445 10.0383 25.0245 10.4706H22.1373Z"
      fill="#2EA373"
    />
    <path
      d="M8.30173 0H0V18.6963H6.31854V13.0665H9.66691C13.3566 13.0665 15.6257 10.689 15.6257 6.86609C15.6257 2.23481 12.5079 0 8.30173 0ZM6.44653 9.71755L2.68423 2.89099L9.52855 3.13824L11.4921 9.70804L6.44653 9.71755Z"
      fill="#2EA373"
    />
  </svg>
);

export const FullLogotypePetroassist = ({ extraClass = "" }) => (
  <svg
    width="140"
    height="20"
    viewBox="0 0 140 20"
    fill="none"
    className={extraClass}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1158_137369)">
      <path
        d="M115.969 6.93459H109.85V19.7006H115.969V6.93459ZM11.3781 11.2112H6.25634L2.36687 4.40898L9.31227 4.65721L11.3781 11.2112ZM15.4894 8.23089C15.4894 3.73128 12.4164 1.57604 8.22971 1.57604H0V19.7006H6.25862V14.2474H9.58387C13.2118 14.2474 15.4894 11.9346 15.4894 8.23089ZM24.8327 11.7218H21.9614C21.9614 10.8314 22.4115 10.0591 23.335 10.0591C23.5416 10.0661 23.7447 10.115 23.9325 10.2028C24.1202 10.2906 24.2888 10.4157 24.4283 10.5705C24.5678 10.7254 24.6754 10.907 24.7449 11.1047C24.8143 11.3025 24.8442 11.5122 24.8327 11.7218ZM30.8546 14.3696C31.165 9.57841 27.6303 6.64303 23.1487 6.64303C19.1522 6.64303 15.9085 9.29078 15.9085 13.5264C15.9085 17.9275 19.5364 20 23.5018 20C26.3925 20 29.7837 18.5776 30.5908 15.5043H24.6542C24.6022 15.7979 24.45 16.0635 24.2244 16.2544C23.9988 16.4454 23.7141 16.5495 23.4203 16.5485C22.1399 16.5485 21.9731 15.398 21.9731 14.3617L30.8546 14.3696ZM39.1503 11.7652L41.1913 11.8913V7.00552L39.1503 7.10008V2.81718H32.9809V7.0922L31.491 6.99764V11.8834L32.9809 11.7652V19.7006H39.1503V11.7652ZM50.263 12.2537C51.039 12.2537 51.4968 12.565 52.137 12.9511V6.64697C50.0728 6.59969 48.9592 6.96218 47.8689 8.6446H47.7254L47.865 6.93853H41.7616V19.7006H47.8767V14.803C47.8767 13.227 48.6838 12.2537 50.2746 12.2537M61.8412 13.3964C61.8522 13.6313 61.8162 13.866 61.7353 14.0863C61.6543 14.3066 61.5302 14.508 61.3704 14.6782C61.2106 14.8483 61.0185 14.9838 60.8056 15.0764C60.5927 15.169 60.3636 15.2167 60.132 15.2167C59.9005 15.2167 59.6713 15.169 59.4584 15.0764C59.2456 14.9838 59.0534 14.8483 58.8936 14.6782C58.7338 14.508 58.6097 14.3066 58.5288 14.0863C58.4478 13.866 58.4118 13.6313 58.4228 13.3964C58.4033 13.1564 58.433 12.9149 58.51 12.6872C58.5871 12.4595 58.7098 12.2505 58.8704 12.0733C59.031 11.8962 59.2261 11.7548 59.4432 11.6581C59.6604 11.5614 59.8949 11.5115 60.132 11.5115C60.3691 11.5115 60.6037 11.5614 60.8208 11.6581C61.038 11.7548 61.233 11.8962 61.3936 12.0733C61.5542 12.2505 61.677 12.4595 61.754 12.6872C61.831 12.9149 61.8607 13.1564 61.8412 13.3964ZM67.77 13.4949C67.77 9.01497 64.2779 6.66273 60.1301 6.66273C55.9822 6.66273 52.494 9.02679 52.494 13.4949C52.494 17.7305 56.1918 20.0158 60.1301 20.0158C64.0684 20.0158 67.77 17.7305 67.77 13.4949ZM77.9902 13.2151C77.9902 14.2002 77.5168 15.1379 76.3528 15.1379C75.1888 15.1379 74.7659 14.275 74.7659 13.2624C74.7511 13.0398 74.781 12.8165 74.8536 12.6059C74.9263 12.3953 75.0402 12.2019 75.1885 12.0373C75.3368 11.8726 75.5165 11.7403 75.7166 11.6481C75.9167 11.556 76.1331 11.506 76.3528 11.5012C76.5737 11.4954 76.7934 11.5361 76.998 11.6209C77.2026 11.7057 77.3877 11.8326 77.5415 11.9936C77.6954 12.1547 77.8147 12.3464 77.8919 12.5566C77.9692 12.7669 78.0026 12.9911 77.9902 13.2151ZM77.7885 19.7006H83.8104V6.93459H77.7885L77.9786 8.4476H77.835C77.4193 7.85981 76.8652 7.38709 76.2234 7.07257C75.5816 6.75804 74.8724 6.61173 74.1606 6.64697C70.618 6.64697 68.678 10.1576 68.678 13.3964C68.678 16.5051 70.5792 20.0158 73.9937 20.0158C75.7281 20.0158 76.7098 19.2474 77.835 18.0457H77.9902L77.7885 19.7006ZM90.9226 10.7683C90.9226 10.3152 91.4193 10.1931 91.7995 10.1931C92.8238 10.2483 93.8074 10.6179 94.6204 11.253L96.1142 7.70686C94.7407 6.91883 92.7967 6.62333 91.2292 6.62333C88.5131 6.62333 85.3469 7.89992 85.3469 11.0993C85.3469 13.5067 87.2443 14.3499 89.2852 14.6454C89.7819 14.7203 90.5191 14.7439 90.5191 15.4334C90.5191 15.9299 90.0186 16.1545 89.6306 16.1545C88.5907 16.1545 87.3529 15.5083 86.4993 14.9724L86.1113 14.7321L84.5592 18.5816C86.3829 19.3696 88.3307 20.0039 90.3212 20.0039C93.1692 20.0039 96.4208 18.6328 96.4208 15.3073C96.4208 12.7384 94.6398 11.9661 92.4592 11.6076C91.6017 11.4578 90.942 11.4106 90.942 10.7841M102.908 10.7841C102.908 10.331 103.405 10.2088 103.785 10.2088C104.81 10.2626 105.794 10.6323 106.606 11.2687L108.1 7.72262C106.726 6.93459 104.782 6.63909 103.219 6.63909C100.503 6.63909 97.3326 7.91568 97.3326 11.1151C97.3326 13.5225 99.2299 14.3656 101.271 14.6612C101.768 14.736 102.505 14.7597 102.505 15.4492C102.505 15.9299 102.004 16.1466 101.601 16.1466C100.557 16.1466 99.3231 15.5004 98.4694 14.9645L98.0814 14.7242L96.5294 18.5737C98.3569 19.3617 100.301 19.9961 102.295 19.9961C105.139 19.9961 108.391 18.6249 108.391 15.2994C108.391 12.7305 106.61 11.9582 104.429 11.5997C103.572 11.45 102.912 11.4027 102.912 10.7762M116.279 2.9866C116.279 1.13081 114.828 0 112.911 0C110.994 0 109.539 1.13081 109.539 2.9866C109.539 5.0788 111.154 5.99291 112.911 5.99291C114.669 5.99291 116.279 5.0788 116.279 2.9866ZM123.473 10.7801C123.473 10.327 123.973 10.2049 124.354 10.2049C125.378 10.2587 126.362 10.6284 127.175 11.2648L128.668 7.71868C127.291 6.93065 125.351 6.63515 123.783 6.63515C121.067 6.63515 117.901 7.91174 117.901 11.1111C117.901 13.5185 119.798 14.3617 121.839 14.6572C122.336 14.7321 123.073 14.7557 123.073 15.4452C123.073 15.9259 122.573 16.1426 122.169 16.1426C121.125 16.1426 119.892 15.4965 119.038 14.9606L118.65 14.7203L117.098 18.5697C118.922 19.3578 120.869 19.9921 122.86 19.9921C125.712 19.9921 128.959 18.621 128.959 15.2955C128.959 12.7266 127.178 11.9543 124.998 11.5957C124.14 11.446 123.477 11.3987 123.477 10.7723M139.052 11.8834V7.00552L137.007 7.0922V2.81718H130.837V7.0922L129.343 6.99764V11.8834L130.837 11.7573V19.7006H137.007V11.7652L139.052 11.8834Z"
        fill="#E25E17"
      />
    </g>
    <defs>
      <clipPath id="clip0_1158_137369">
        <rect width="139.048" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ShortLogotype = ({ extraClass, isGroupWebsite }) =>
  isGroupWebsite ? (
    <svg
      className={extraClass}
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 3.61809C0 1.61988 1.61987 0 3.61809 0H32.3819C34.3801 0 36 1.61987 36 3.61809V32.3819C36 34.3801 34.3801 36 32.3819 36H3.61809C1.61988 36 0 34.3801 0 32.3819V3.61809Z"
        fill="#899BA8"
      />
      <path
        d="M22.9553 7.41797L31.918 28.6584L17.7308 28.6818L4.1581 7.41797H22.9553Z"
        fill="#E2E6E5"
      />
    </svg>
  ) : (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="inherit"
      className={extraClass}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.61809 0C1.61987 0 0 1.61988 0 3.61809V32.3819C0 34.3801 1.61988 36 3.61809 36H32.3819C34.3801 36 36 34.3801 36 32.3819V3.61809C36 1.61987 34.3801 0 32.3819 0H3.61809ZM31.92 28.6584L22.9573 7.41797H4.16016L17.7328 28.6818L31.92 28.6584Z"
        fill="inherit"
      />
    </svg>
  );

export const UpploadFileIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="mb-12"
  >
    <path
      d="M12 22V13M12 13L15.5 16.5M12 13L8.5 16.5M20 17.6073C21.4937 17.0221 23 15.6889 23 13C23 9 19.6667 8 18 8C18 6 18 2 12 2C6 2 6 6 6 8C4.33333 8 1 9 1 13C1 15.6889 2.50628 17.0221 4 17.6073"
      stroke="#5B646C"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MapMarkerIcon = ({ extraclass = "" }) => (
  <svg
    width="34"
    height="34"
    viewBox="0 0 34 34"
    fill="inherit"
    className={extraclass}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_516_172223)">
      <path
        d="M28.3307 14.1654C28.3307 22.6654 16.9974 31.1654 16.9974 31.1654C16.9974 31.1654 5.66406 22.6654 5.66406 14.1654C5.66406 11.1596 6.85811 8.2769 8.98352 6.15149C11.1089 4.02608 13.9916 2.83203 16.9974 2.83203C20.0032 2.83203 22.8859 4.02608 25.0113 6.15149C27.1367 8.2769 28.3307 11.1596 28.3307 14.1654Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 18.418C19.3472 18.418 21.25 16.5152 21.25 14.168C21.25 11.8208 19.3472 9.91797 17 9.91797C14.6528 9.91797 12.75 11.8208 12.75 14.168C12.75 16.5152 14.6528 18.418 17 18.418Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g clipPath="url(#clip1_516_172223)">
        <path
          d="M28.3307 14.1654C28.3307 22.6654 16.9974 31.1654 16.9974 31.1654C16.9974 31.1654 5.66406 22.6654 5.66406 14.1654C5.66406 11.1596 6.85811 8.2769 8.98352 6.15149C11.1089 4.02608 13.9916 2.83203 16.9974 2.83203C20.0032 2.83203 22.8859 4.02608 25.0113 6.15149C27.1367 8.2769 28.3307 11.1596 28.3307 14.1654Z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17 18.418C19.3472 18.418 21.25 16.5152 21.25 14.168C21.25 11.8208 19.3472 9.91797 17 9.91797C14.6528 9.91797 12.75 11.8208 12.75 14.168C12.75 16.5152 14.6528 18.418 17 18.418Z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M28.3307 14.1654C28.3307 22.6654 16.9974 31.1654 16.9974 31.1654C16.9974 31.1654 5.66406 22.6654 5.66406 14.1654C5.66406 11.1596 6.85811 8.2769 8.98352 6.15149C11.1089 4.02608 13.9916 2.83203 16.9974 2.83203C20.0032 2.83203 22.8859 4.02608 25.0113 6.15149C27.1367 8.2769 28.3307 11.1596 28.3307 14.1654Z"
          fill="inherit"
          stroke="inherit"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17 18.418C19.3472 18.418 21.25 16.5152 21.25 14.168C21.25 11.8208 19.3472 9.91797 17 9.91797C14.6528 9.91797 12.75 11.8208 12.75 14.168C12.75 16.5152 14.6528 18.418 17 18.418Z"
          fill="#EDF0F1"
          stroke="#EDF0F1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_516_172223">
        <rect width="34" height="34" fill="white" />
      </clipPath>
      <clipPath id="clip1_516_172223">
        <rect width="34" height="34" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
